// Libs
import React from 'react'
import { BrowserRouter as Router, } from 'react-router-dom'

// Routes
import Routes from './routes'

const Root = () => (
  <Router>{Routes}</Router>
)

export default Root
